module.exports = __webpack_public_path__ + "images/header-shard-left.svg";